import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { StoreIcon, OneManDeliveryIcon, ThirtyDayReturnIcon } from '@sainsburys-tech/bolt-icons'

import * as Styled from './TuFulfilmentBlock.styles'

class TuFulfilmentBlock extends Component {
  render() {
    const {
      collectionInfoTitle,
      deliveryInfoTitle,
      returnInfoTitle,
      collectionInfoDetails,
      deliveryInfoDetails,
      returnInfoDetails,
      collectionInfoValue,
      deliveryInfoValue,
      returnInfoValue,
      headerText,
      type
    } = this.props

    const fulfilmentInfoCollectionOptions = {
      icon: <StoreIcon width={24} height={24} />,
      infoTitle: collectionInfoTitle,
      infoDetails: collectionInfoDetails,
      infoValue: collectionInfoValue
    }

    const fulfilmentInfoDeliveryOptions = {
      icon: <OneManDeliveryIcon width={24} height={24} />,
      infoTitle: deliveryInfoTitle,
      infoDetails: deliveryInfoDetails,
      infoValue: deliveryInfoValue,
      type
    }

    const fulfilmentInfoReturnOptions = {
      icon: <ThirtyDayReturnIcon width={24} height={24} />,
      infoTitle: returnInfoTitle,
      infoDetails: returnInfoDetails,
      infoValue: returnInfoValue,
      type
    }

    const determineDeliveryInfoOrdering = () => {
      if (type !== 'TU_ON_ARGOS') {
        return (
          <>
            <Styled.Label data-test='tu-fulfilment-label-info-return'>
              <TempTuFulfilmentInfo {...fulfilmentInfoReturnOptions} />
            </Styled.Label>

            <Styled.Label data-test='tu-fulfilment-label-info-delivery'>
              <TuFulfilmentInfo {...fulfilmentInfoDeliveryOptions} />
            </Styled.Label>
          </>
        )
      }
      return (
        <>
          <Styled.Label data-test='tu-fulfilment-label-info-delivery'>
            <TuFulfilmentInfo {...fulfilmentInfoDeliveryOptions} />
          </Styled.Label>

          <Styled.Label data-test='tu-fulfilment-label-info-return'>
            <TempTuFulfilmentInfo {...fulfilmentInfoReturnOptions} />
          </Styled.Label>
        </>
      )
    }

    return (
      <Styled.TuFulfilmentBox data-test='tu-fulfilment-box'>
        <h3 data-test='tu-fulfilment-header'>{headerText}</h3>
        <Styled.Label data-test='tu-fulfilment-label-info-collection'>
          <TuFulfilmentInfo {...fulfilmentInfoCollectionOptions} />
        </Styled.Label>

        {determineDeliveryInfoOrdering(type)}
      </Styled.TuFulfilmentBox>
    )
  }
}

TuFulfilmentBlock.propTypes = {
  collectionInfoTitle: PropTypes.string,
  deliveryInfoTitle: PropTypes.string,
  returnInfoTitle: PropTypes.string,

  collectionInfoDetails: PropTypes.string,
  deliveryInfoDetails: PropTypes.string,
  returnInfoDetails: PropTypes.string,

  collectionInfoValue: PropTypes.string,
  deliveryInfoValue: PropTypes.string,
  returnInfoValue: PropTypes.string,

  headerText: PropTypes.string
}

TuFulfilmentBlock.defaultProps = {
  collectionInfoTitle: 'Free Click & Collection on orders over £20',
  deliveryInfoTitle: 'Next, named & stanard delivery',
  returnInfoTitle: 'Free returns to stores',

  collectionInfoDetails: '',
  deliveryInfoDetails: '',
  returnInfoDetails: '',

  collectionInfoValue: '',
  deliveryInfoValue: '',
  returnInfoValue: '',

  headerText: 'Delivery & Returns'
}

const TuFulfilmentInfo = ({ icon, infoTitle, infoDetails = '', infoValue }) => (
  <>
    <div className='info-details'>
      {icon}
      <p className='title' data-test='title'>
        <strong>{infoTitle}</strong>
      </p>
      <p>{infoDetails}</p>
    </div>
    <Styled.TuFulfilmentPrice data-test='tu-fulfilment-price'>{infoValue}</Styled.TuFulfilmentPrice>
  </>
)

// Temporary because of COVID-19
const TempTuFulfilmentInfo = ({ icon, infoTitle, infoDetails = '', type }) => (
  <>
    <div className='info-details'>
      {icon}
      <p className='title' data-test='title'>
        <strong>{infoTitle}</strong>
      </p>
      <p>{infoDetails}</p>
    </div>
    {type === 'TU_ON_ARGOS' && (
      <a href='//www.argos.co.uk/help/faq/72647?search=can-I-still-return-an-item'>More info</a>
    )}
  </>
)

export default TuFulfilmentBlock
export { TuFulfilmentInfo }
